import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { contactInfo } from '../config/contactInfo';

const ThankYou = () => {
  const location = useLocation();
  const [emailSent, setEmailSent] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(true);

  const getOrderId = () => {
    const params = new URLSearchParams(location.search);
    return params.get('id') || params.get('order_id') || '-';
  };

  const getPaymentMethod = () => {
    const params = new URLSearchParams(location.search);
    return params.get('method') || 'cashfree';
  };

  const orderId = getOrderId();
  const paymentMethod = getPaymentMethod();

  useEffect(() => {
    const sendThankYouEmail = async () => {
      if (!orderId || orderId === '-') {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`https://nqa1.in/api/${paymentMethod}/mail/send`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            order_id: orderId
          })
        });

        const data = await response.json();

        if (data.success) {
          setEmailSent(true);
        } else {
          setEmailError(data.message || 'Failed to send confirmation email');
        }
      } catch (err) {
        console.error('Email error:', err);
        setEmailError('Unable to send confirmation email');
      } finally {
        setLoading(false);
      }
    };

    sendThankYouEmail();
  }, [orderId, paymentMethod]);

  const formattedDate = new Date().toLocaleString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', padding: '20px' }}>
      <div style={{ maxWidth: 700, width: '100%', background: '#fff', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.12)', padding: 28 }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 64, color: '#4CAF50' }}>✓</div>
          <h1 style={{ margin: '10px 0', fontSize: 28 }}>Thank You!</h1>
          <p style={{ color: '#555' }}>Your donation has been successfully received.</p>
        </div>

        <div style={{ background: '#f7f7f9', borderRadius: 8, padding: 16, margin: '20px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e3e3e7' }}>
            <span style={{ fontWeight: 600 }}>Order ID:</span>
            <span>{orderId}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ fontWeight: 600 }}>Date:</span>
            <span>{formattedDate}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ fontWeight: 600 }}>Status:</span>
            <span style={{ color: '#2e7d32', fontWeight: 700 }}>Payment Successful</span>
          </div>
        </div>

        <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: 12, borderRadius: 8, borderLeft: '4px solid #4CAF50' }}>
          {loading ? (
            '⏳ Sending confirmation email...'
          ) : emailSent ? (
            '✓ A confirmation email has been sent to your registered email address.'
          ) : (
            '⚠ Unable to send confirmation email, but your payment was successful.'
          )}
        </div>

        <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
          <Link to="/" className="btn read-more-btn" style={{ textDecoration: 'none' }}>
            Back to Home
          </Link>
          <button className="btn" onClick={() => window.print()} style={{ border: '1px solid #ddd' }}>
            Print Receipt
          </button>
        </div>

        <p style={{ color: '#888', fontSize: 13, marginTop: 18 }}>
          If you have any questions about your donation, please contact us at
          <br />
          <strong>{contactInfo.email}</strong> or call <strong>+91-{contactInfo.phone}</strong>
        </p>
      </div>
    </div>
  );
};

export default ThankYou;
